/**
 * Hierarchical TanStack Query keys for population dimensions (group
 * categories, report dimensions, breakdowns).
 *
 * The ESA pattern (lib/esa/query-keys.ts): NO `mode` and NO `workspaceId` in
 * any key. Tenant isolation is WorkspaceCacheGuard (queryClient.clear() on a
 * workspace or company switch) plus the `x-workspace-id` header fetchApi
 * attaches. Keys carry the resource and its filters only, so a targeted
 * `invalidateQueries({ queryKey: populationKeys.<ns>.all() })` refreshes one
 * namespace.
 */
export const populationKeys = {
  all: () => ['population'] as const,

  categories: {
    all: () => [...populationKeys.all(), 'group-categories'] as const,
    list: () => [...populationKeys.categories.all(), 'list'] as const,
  },

  dimensions: {
    all: () => [...populationKeys.all(), 'dimensions'] as const,
    list: () => [...populationKeys.dimensions.all(), 'list'] as const,
  },

  breakdowns: {
    all: () => [...populationKeys.all(), 'breakdown'] as const,
    /** `qs` is the whole request query (dimension, report window, population). */
    phishing: (qs: string) => [...populationKeys.breakdowns.all(), 'phishing', qs] as const,
    lms: (qs: string) => [...populationKeys.breakdowns.all(), 'lms', qs] as const,
  },
}
